import React, { Component } from 'react';

import { createHashHistory } from 'history';
import { getLog } from '../ajax/index.js';
const history = createHashHistory();
const nullvalue = require('../assets/images/home/img_error.png');
class A extends Component {
    constructor(props) {
        super(props);
        this.state = {}

    }
    componentDidMount() {
        let currentUrl = window.location.href;
        let appId = 'tsp.errorcode';
        let pointName = `/systemerror`;
        getLog(currentUrl, appId, pointName);
    }
    gohome() {
        history.push('/')
    }
    render() {
        return (
            <div className="transition-item detail-page">
                <div style={{ paddingBottom: '44px', background: '#fff', height: '690px' }}>
                    <div>
                        <img width="100%" src={nullvalue} alt="图片" />
                        <h2 style={{ fontFamily: 'Helvetica', fontSize: '18px', color: '#656667', textAlign: 'center', lineHeight: '50px', fontWeight: 100 }}>Maintaining!
                    <br />Service Paused </h2>
                    </div>
                    <div style={{ marginTop: '100px', textAlign: 'center' }}>
                        <button style={{ background: '#4C84FF', borderRadius: '4px', border: 0, height: '36px', width: '85%', color: '#fff', fontFamily: 'SFUIText-Medium', fontSize: '16px', color: '#FFFFFF', letterSpacing: '-0.69px' }} onClick={this.gohome} className="code-btn">Back to Home </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default A


// WEBPACK FOOTER //
// ./src/components/systemError.js